import { ForgotPasswordForm } from '../components/forgot-password-form';
import { MarcoDeIngreso, TarjetaDeIngreso, TituloDeIngreso } from '../components/marco-de-ingreso';

export function ForgotPasswordPage() {
  return (
    <MarcoDeIngreso>
      <TituloDeIngreso
        antes="Recupera tu acceso"
        subtitulo="Te mandamos un enlace para crear una contraseña nueva."
      />
      <TarjetaDeIngreso>
        <ForgotPasswordForm />
      </TarjetaDeIngreso>
    </MarcoDeIngreso>
  );
}

export default ForgotPasswordPage;
